import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class FeltoltesTesztlapDto extends IdentifiableDto {
	constructor() {
		super();
		this.csomagNev = null;
		this.szkenneltFilename = null;
		this.szkenneltPath = null;
		this.vizsgaTesztlap = null;
	}

	setup(props) {
		super.setup(props);
		this.csomagNev = props.csomagNev;
		this.szkenneltFilename = props.szkenneltFilename;
		this.szkenneltPath = props.szkenneltPath;
		this.vizsgaTesztlap = props.vizsgaTesztlap;
		return this;
	}
}

export default FeltoltesTesztlapDto;
